import styled from "styled-components";

export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  background: #d21033;
  padding: 5px 0;
  width: 100%;

  #footer{
    padding: 10px;
    width: 100%;
    background: #d21033;
    max-width: 100%;
    color: #ffffff;
  }

  & p {
    color: #fff;
    padding-left: 40rem;
    align-items: center !important;

    @media (max-width: 827px) {
      padding-left: 3rem;
    }

    @media (max-width: 310px) {
      padding-left: 1.5rem;
    }

    @media (max-width: 230px) {
      padding-left: 0.5rem;
    }
  }
`;
